import createReactComponent from '../createReactComponent';
export default createReactComponent('chart-pie-two', 'ChartPieTwo', [["path",{"d":"M12 3a9 9 0 1 0 6.364 15.364M12 3a9 9 0 0 1 6.364 15.364M12 3v9l6.364 6.364","key":"svg-0"}]]);